import {createSlice} from "@reduxjs/toolkit";
import {colorPrimary, colorSecondary} from "../../Constants/theme";

export const reducerName = "branding";
export const initialState = {
    partnerId: null,
    clinicId: null,
    type: null,
    redirectUrl: null,
    partnerPreferencesOn: false,
    url: "",
    websiteURL: "",
    name: "",
    logo: "",
    brandHeader: colorPrimary,
    headerText: "",
    bodyText: "",
    brandText: colorPrimary,
    brandAccent: colorSecondary,
    buttonText: colorPrimary,
    headerFont: "Merriweather",
    textFont: "DMSans",
    partnerStatus: "ACTIVE"
};

const brandingReducer = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setPartnerBranding: (state, action) => ({
            ...state,
            ...action.payload
        }),
        setIsPartnerPreferencesOn: (state) => ({
            ...state,
            partnerPreferencesOn: true,
        }),
        setIsPartnerPreferencesOff: (state) => ({
            ...state,
            partnerPreferencesOn: false,
        }),
        setPartnerName: (state, action) => ({
            ...state,
            name: action.payload
        }),
        setPartnerLogo: (state, action) => ({
            ...state,
            logo: action.payload
        }),
        setInitialBranding: () => initialState,
    }
});

export default brandingReducer.reducer;
export const {
    setInitialBranding,
    setPartnerBranding,
    setIsPartnerPreferencesOn,
    setPartnerName,
    setPartnerLogo,
    setIsPartnerPreferencesOff
} = brandingReducer.actions;
